import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_include_periods_maternity_leave_workers'

export const dataPointDefinition = {
  retracedId: 'does_facility_include_periods_maternity_leave_workers',
  name: "Does the facility include all periods of maternity leave in the workers' period of continuous service?",
  description:
    "The intent of this question is to understand if the facility includes all periods of maternity leave in the workers' period of continuous service (i.e. if the time taken off for maternity leave is considered as part of workers' period of service when determining their rights and benefits).",
  meta: {
    slcpMeta: {
      key: 'wt-dis-29',
      number: 'WT-DIS-12',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-29', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37260,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
